'use client'

import { useDisclosureContext, useStoreState } from '@ariakit/react'
import { type ComponentProps } from 'react'
import styled from 'styled-components'

import { BaseIcon } from '@syconium/little-miss-figgy/dist/components/Icons/BaseIcon'
import { Carat } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/Carat'
import { Minus } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/Minus'
import { Plus } from '@syconium/little-miss-figgy/dist/components/Icons/Icon/Plus'
import { timingDefault } from '@syconium/little-miss-figgy/dist/constants/timing'

type StyledCaretProps = {
  $isOpen: boolean
}

const StyledCaret = styled(Carat)<StyledCaretProps>`
  height: ${o => (o.$isOpen ? '13px' : '15px')};
  margin-inline-end: ${o =>
    o.$isOpen
      ? o.theme.dimensions.layout.sidePadding.md + 1
      : o.theme.dimensions.layout.sidePadding.md}px;
  transform: rotate(90deg) ${o => (o.$isOpen ? 'rotateY(180deg)' : '')};
  transition: all ${timingDefault};
  width: ${o => (o.$isOpen ? '13px' : '15px')};
`

export const DisclosureSummaryCaratIcon = () => {
  const disclosureContext = useDisclosureContext()
  const disclosureState = useStoreState(disclosureContext)
  const isOpen = disclosureState?.open ?? false
  return <StyledCaret $isOpen={isOpen} />
}

type DisclosureSummaryPlusIconProps = Omit<ComponentProps<typeof BaseIcon>, 'stroke'>

export const DisclosureSummaryPlusIcon = (props: DisclosureSummaryPlusIconProps) => {
  const disclosureContext = useDisclosureContext()
  const disclosureState = useStoreState(disclosureContext)
  const isOpen = disclosureState?.open ?? false
  return isOpen ? (
    <Minus stroke='currentcolor' {...props} />
  ) : (
    <Plus stroke='currentcolor' {...props} />
  )
}
